import { youtubeEmbedUrl } from '@/utils/youtube';

export const YoutubePreview = ({
  url,
  title,
  unavailableLabel,
  watchLabel,
}: {
  url: string;
  title: string;
  unavailableLabel: string;
  watchLabel: string;
}) => {
  const embedUrl = youtubeEmbedUrl(url);

  if (!embedUrl) {
    return (
      <div className="flex aspect-video w-full flex-col items-center justify-center gap-3 rounded-lg bg-surface-sunken px-4 text-center">
        <p className="text-body-sm text-fg-secondary">{unavailableLabel}</p>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-body-sm font-medium text-brand hover:underline"
        >
          {watchLabel}
        </a>
      </div>
    );
  }

  return (
    <div className="relative aspect-video w-full overflow-hidden rounded-lg bg-surface-sunken">
      <iframe
        src={embedUrl}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        className="absolute inset-0 size-full border-0"
      />
    </div>
  );
};
